// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateEmissionsPartSearchCriteria = partNumber => ({
    partNumber: partNumber.replace(/^\s*$/, ''),
    type: actions.UPDATE_EMISSIONS_PART_SEARCH_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/action-creators/criteria.js